<!--
 * @Author: wh
 * @Date: 2020-08-13 21:45:29
 * @LastEditTime: 2020-09-25 11:43:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\productFlow.vue
-->
<template>
    <div class="dataBulletin-productFlow">
        <div class="block">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>
        <div class="split"></div>
        <div class="pie-chart block">
            <h4>产品流向结构分析</h4>
            <div id="pieChart" class="chart"></div>
        </div>
        <div class="split"></div>
        <div class="line-chart block">
            <h4>量价结构分析</h4>
            <div id="lineChart" class="chart"></div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月日"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_blue from '@/assets/images/home/bg_blue.png';
export default {
    components: {},
    props: {},
    data() {
        return {
            showCalendarPop: false,
            currentDate: new Date(),
            date: '',
            showOrgPop: false,
            columns: [
                {
                    text: '全部',
                    children: [],
                },
            ],
            // 图表数据
            data: {},
            // 组织机构
            orgData: [],
            orgName: '全部',
            dic_code: '',
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.date = year + '-' + month;
            this.getOrg();
            this.getSaleday();
        },
        async getOrg() {
            const yyq = await this.getOrgApi();
            if (yyq) {
                const res = yyq.map(item => {
                    item.text = item.dic_name;
                    if (item.children) {
                        item.children = item.children.map(v => {
                            v.text = v.dic_name;
                            return v;
                        });
                    } else {
                        item.children = [];
                    }
                    return item;
                });
                this.orgData = res;
                this.columns[0].children = this.orgData;
            }
        },
        async getSaleday() {
            const res = await this.getSaledayApi();
            if (res) {
                this.data = res;
                this.initLineChart();
                this.initPieChart();
            }
        },

        // 获取数据    
        getSaledayApi() {
            const data = {
                date: this.date,
                dic_code: this.dic_code,
            };
            const path = '/interfaceApi/report/data_express/product_flow';
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 获取组织结构    
        getOrgApi() {
            const path = '/interfaceApi/report/dictionary/get_dictionary_tree?group_code=jt_data_express_tenant&isAddSelect=true';
            return this.$axios.$get(path, { defEx: true });
        },
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.getSaleday();
        },
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        confirmOrg(value) {
            this.showOrgPop = false;

            this.orgName = '';
            if (value[0]) {
                this.orgName += value[0];
            }
            if (value[1] && value[1] !== '请选择') {
                this.orgName = value[1];
            }
            if (value[2] && value[2] !== '请选择') {
                this.orgName += '-' + value[2];
            }

            if (value[2] && value[2] !== '请选择') {
                this.orgData.map(item => {
                    if (item.children) {
                        item.children.map(v => {
                            if (v.text === value[2]) {
                                this.dic_code = v.dic_code;
                            }
                        });
                    }
                });
            } else if (value[1] && value[1] !== '请选择') {
                this.orgData.map(item => {
                    if (item.text === value[1]) {
                        this.dic_code = item.dic_code;
                    }
                });
            } else {
                this.dic_code = '';
            }
            this.getSaleday();
        },
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 量价结构分析
        initLineChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                legend: {
                    data: ['销量', '价格'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.data.engineering_type,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(万方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(元/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '销量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(85,167,254,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(62,121,197,1)', // 100% 处的颜色
                            }], false),
                        },
                        label: {
                            show: true,
                            position: 'top',
                            fontSize: '12',
                            color: 'rgba(62,121,197,1)',
                            lineHeight: 22,
                            padding: [0, 10, 4, 10],
                            backgroundColor: {
                                image: bg_blue,
                            },
                        },
                        barWidth: 30,
                        data: this.data.engineering_type_quantity,
                    },
                    {
                        name: '价格',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        label: {
                            show: true,
                            position: 'bottom',
                            fontSize: '12',
                            padding: 0,
                            color: '#FA8436',
                        },
                        yAxisIndex: 1,
                        data: this.data.engineering_type_price,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        initPieChart() {
            const myChart = this.$echarts.init(document.getElementById('pieChart'));
            const type = this.data.engineering_type;
            const quantity = this.data.engineering_type_quantity;
            const data = [];
            if (type) {
                type.map((item, index) => {
                    const json = { name: '', value: '' };
                    json.name = item;
                    json.value = quantity[index];
                    data.push(json);
                });
            }
            const option = {
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}({d}%):{c}',
                },
                series: [
                    {
                        type: 'pie',
                        data: data,
                        center: ['50%', '55%'],
                        label: {
                            show: true,
                            position: 'outside',
                            formatter: '{b}({d}%)\n{c}',
                            rich: {
                                d: {
                                    color: '#979EA7',
                                },
                                c: {
                                    color: '#67ddff',
                                    fontSize: 18,
                                },
                            },
                        },
                        labelLine: {
                            length: 6,
                            length2: 4,
                            show: true,
                        },
                        itemStyle: {
                            borderWidth: 2,
                            borderColor: '#FFFFFF',
                        },
                        clockwise: true,
                        animation: false,
                        color: ['#7CB957', '#FBA736', '#3296DF', '#3DB7AA', '#F65C6A', '#C650DF', '#8B6BEE'],
                    },
                ],
                backgroundColor: '#FFFFFF',
            };
            myChart.setOption(option, true);
        },
    },
};
</script>
<style lang="stylus">
.dataBulletin-productFlow
    height 100%
    overflow-y auto
    .block
        background #fff
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
        .statistics
            .row
                display flex
                justify-content space-between
                margin-top 10rpx
                .item
                    flex 1
                    flex-shrink 0
                    width 33.333%
                    font-size 12rpx
                    color #979EA7
                    .iconfont
                        font-size 12rpx
                        color #979EA7
                        margin-right 3rpx
                    .rectangle
                        margin-top 5rpx
                        height 40rpx
                        background rgba(85,136,241,0.06)
                        border-radius 4rpx
                        text-align center
                        line-height 40rpx
                        font-size 18rpx
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    .item-text
                        text-align center
                    &.sales
                        margin 0 5rpx
                        .rectangle
                            background rgba(250,132,54,0.06)
                            color #FA8436
                    &.volume
                        .rectangle
                            background rgba(85,136,241,0.06)
                            color #5588F1
                    &.price
                        .rectangle
                            background rgba(33,189,204,0.06)
                            color #21BDCC
    .split
        height 15rpx
        background #F0F0F0
    .pie-chart
        height 266rpx
        h4
            margin-bottom .2rem
        .chart
            width 100%
            height calc(100% - 30rpx)
    .line-chart
        height 300rpx
        h4
            margin-bottom 20rpx
        .chart
            width 100%
            height calc(100% - 40rpx)
</style>